// Shared labels + types for Manufacturer Intelligence signals (Feature #47, M3).
// Leaner than accountSignals.ts — manufacturer signals carry only
// domain/title/body/source_url/observed_on (no aspect/polarity/horizon/etc.).

export type SignalStatus = "pending" | "approved" | "rejected"
export type SignalOrigin = "research" | "manual"

export type Signal = {
  id: number
  domain: string | null
  title: string
  body: string | null
  source_url: string | null
  observed_on: string | null
  origin: SignalOrigin
  status: SignalStatus
  run_id: number | null
  created_at: string
}

// The 10-facet competitor-intelligence taxonomy (mirrors ManufacturerSignal::DOMAINS),
// in Bahasa Indonesia. Used as the timeline filter + per-signal label.
export const DOMAIN_LABELS: Record<string, string> = {
  brand_portfolio: "Portofolio Merek",
  product_innovation: "Inovasi Produk",
  pricing_strategy: "Strategi Harga",
  distribution_channel: "Saluran Distribusi",
  marketing_advertising: "Pemasaran & Iklan",
  market_position: "Posisi Pasar",
  corporate_strategy: "Strategi Korporat",
  manufacturing_supply: "Manufaktur & Pasokan",
  regulatory_sustainability: "Regulasi & Keberlanjutan",
  reputation_crisis: "Reputasi & Krisis",
}

export function humanize(value: string): string {
  return value
    .split("_")
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ")
}

export function domainLabel(domain: string | null): string {
  if (!domain) return "Tanpa domain"
  return DOMAIN_LABELS[domain] ?? humanize(domain)
}
